type Props = {
    href: string;
    icon: React.ReactNode;
    onClick?: () => void;
}

export const SocialLink = ({ href, icon, onClick }: Props) => {
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className="rounded-md flex border border-gray-800 items-center justify-center h-12 w-12 hover:opacity-70 transition-opacity duration-200" >
          {icon}
        </a>
    )
}
